import { useQuery } from '@apollo/client';
import { USER_SAVINGS } from '../userTypeDefs';

export const useQueryUserSavings = (options?: any): any => (
  useQuery(USER_SAVINGS, options)
);


